import config from '../../config';

const getWidget = async widgetUrl => {
  const dateTime = new Date().toISOString();
  const url = `${config.widgetApi.baseUrl}/${widgetUrl}?dateTime=${dateTime}`;
  // use dev widgets to test production accounts
  // const url = `https://dev-widgets.admobilize.com/${widgetUrl}?dateTime=${dateTime}`;
  let response;
  try {
    response = await fetch(url);
  } catch (error) {
    if (!(error instanceof TypeError)) throw error;
    response = await fetch(url); // One retry for a transient network failure.
  }
  if (!response.ok) throw new Error(`Failed to load widget ${widgetUrl} (${response.status})`);
  return response.json();
};

export { getWidget };
